import clsx from "classnames";
import classes from "./styles.module.scss";
import Link from 'next/link';

export default function Button({ display, variant, link = '', newTab=false, className, animation=false }) {
  return (
     <Link href={link} target={newTab ? "_blank" : "_self"} passHref>
        <button className={`${className} ${classes.button} ${variant === 'btn-primary' && classes.primary} ${variant === 'btn-quatenary' && classes.quatenary} ${animation ? classes.animation : ''}`}>{display}</button>
     </Link>
  );
}

Button.defaultProps = {
  className: "",
};
